class @YesNoFieldToggler

  @yesNoTogglers: []
  @yesNoParentShown: "yesno-parent-shown"
  @yesNoParentHidden: "yesno-parent-hidden"

  @setup: ->
    $("[data-yesno-toggles]").each ->
      $yesNoContainer = $(this)
      $enabled        = $yesNoContainer.find("input[value='true']")
      $disabled       = $yesNoContainer.find("input[value='false']")
      $fields         = $($yesNoContainer.attr("data-yesno-toggles"))
      toggler         = new YesNoFieldToggler($yesNoContainer, $enabled, $disabled, $fields)
      YesNoFieldToggler.yesNoTogglers.push(toggler)
    $("[data-yesno-toggles-inverted]").each ->
      $yesNoContainer = $(this)
      $enabled        = $yesNoContainer.find("input[value='false']")
      $disabled       = $yesNoContainer.find("input[value='true']")
      $fields         = $($yesNoContainer.attr("data-yesno-toggles-inverted"))
      toggler         = new YesNoFieldToggler($yesNoContainer, $enabled, $disabled, $fields)
      YesNoFieldToggler.yesNoTogglers.push(toggler)

  @checkAll: ->
    for toggler in YesNoFieldToggler.yesNoTogglers
      toggler.adjust()

  constructor: (@$yesNoContainer, @$enabled, @$disabled, @$toggledFields) ->
    @$toggledFieldContainers = @$toggledFields.closest(".form-field").add(@$toggledFields.filter("li.form-field"))
    @$toggledFields = @$toggledFields.not("li.form-field")
    @$enabled.add(@$disabled).on("change", @adjust)
    @$toggledFields.add(@$toggledFieldContainers).toggle(@enabled())
    @$yesNoContainer.on(YesNoFieldToggler.yesNoParentHidden, @hide)
    @$yesNoContainer.on(YesNoFieldToggler.yesNoParentShown, @adjust)

  enabled: =>
    @$enabled.is(":visible") && @$enabled.is(":checked")

  show: =>
    @$toggledFields.show()
    @$toggledFieldContainers.slideDown()
    @$toggledFieldContainers.find(":input").removeAttr("disabled")
    @triggerSubTogglers(YesNoFieldToggler.yesNoParentShown)
    @findAndActivateAnyHugerteEditors()

  hide: =>
    @$toggledFields.hide()
    @$toggledFieldContainers.slideUp()
    @$toggledFieldContainers.find(":input").attr("disabled", "disabled")
    @triggerSubTogglers(YesNoFieldToggler.yesNoParentHidden)

  adjust: =>
    if @enabled()
      @show()
    else
      @hide()

  triggerSubTogglers: (message) =>
    $searchSelectors = @$toggledFields.add(@$toggledFieldContainers)
    UI.findAndSelf("[data-yesno-toggles]", $searchSelectors).trigger(message)

  # Find any HugeRTE editors that are inside the panel being activated. If
  # there are, and it hasn't yet been show, show it now.
  findAndActivateAnyHugerteEditors: =>
    UI.findAndSelf("textarea.hugerte", @$toggledFields).each ->
      textarea = @
      $(textarea).hide()
      editors  = _.filter(hugerte.get(), (e) => e.hidden && textarea.id == e.id)
      for editor in editors
        editor.show()
